import { WixCustomElementComponentSiteConfig } from './types'

export const generateWixCodeUrl = (
	veloBundlerUrlData: WixCustomElementComponentSiteConfig['veloBundlerUrlData'],
	url: string
) => {
	const queryParams = veloBundlerUrlData.queryParams ? `&${veloBundlerUrlData.queryParams}` : ''
	const head = veloBundlerUrlData.url + url.replace('public/', '')
	return `${head}?no-umd=true${queryParams}`
}
